import styled, { DefaultTheme, ThemedStyledProps } from 'styled-components';
import BaseOverlay from 'components/Overlay';
import {
  BACKDROP_COLOR,
  BACKDROP_TRANSITION_DURATION_MILLIS,
  BACKDROP_Z_INDEX,
} from './constants';
import { OverlayStyleProps } from './types';

const transitionStyles = {
  entering: 'opacity: 1',
  entered: 'opacity: 1',
  exiting: 'opacity: 0',
  exited: 'opacity: 0',
  unmounted: '',
};

function getContentsLayout(
  props: ThemedStyledProps<OverlayStyleProps, DefaultTheme>,
) {
  const { contentsPosition, theme } = props;

  if (contentsPosition === 'center') {
    return 'align-items: center';
  }

  if (contentsPosition === 'end') {
    return 'align-items: flex-end';
  }

  if (contentsPosition === 'start') {
    return 'align-items: flex-start';
  }

  return `
  align-items: flex-start;
  padding-top: ${theme.spacing.dialogOffset}px`;
}

export const Overlay = styled(BaseOverlay)<OverlayStyleProps>`
  background-color: ${BACKDROP_COLOR};
  display: flex;
  justify-content: center;
  opacity: 0;
  transition: ${({ theme }) =>
    theme.transitions.create(
      'opacity',
      `${BACKDROP_TRANSITION_DURATION_MILLIS}ms`,
    )};
  z-index: ${BACKDROP_Z_INDEX};

  ${getContentsLayout};
  ${({ transitionStatus }) => transitionStyles[transitionStatus]};
`;
